import React from 'react';
import { connect } from "react-redux";
import PropTypes from "prop-types";

import {setCameFromPage, toggleSelectionFeatureInfo} from "../../../actions/actionFunctions";
import FeatureThumbnail from "../../visComponents/featureThumbnail";
import FeatureName from "../../visComponents/featureName";
import FeatureInfoDescription from "../selectionFeatureInfo/featureInfoDescription";
import FeatureInfoPrice from "../selectionFeatureInfo/featureInfoPrice";
import FeatureInfoPriceLocked from "../selectionFeatureInfo/featureInfoPriceLocked";
import {getFeatureIsLocked} from "../../../misc/helpers";
import SelectionMainListRowItemButtons from "./rowItemButtons";
import RowItemRelatedProductsButton from "./rowItemRelatedProductsButton";
import FeatureCartItemsCount from "../featureCartItemsCount";
import {wizardGroupInterface} from "../../../interfaces/wizardItemInterface";
import {shouldReplaceSelectionInfoFeature} from "../../qkbPages/materialsCommon/materialsCommonFunctions";
import SuperAdminFeatureToolSettingsButton from "../../qkbPages/superAdmin/SuperAdminFeatureToolSettingsButton";
import {getDifferentToolSettings} from "../../qkbPages/superAdmin/adminFunctions";


const RowItem = (props) => {

  const {selected, currentFeature, fabricatorData, handleFeatureClick, toggleSelectionFeatureInfo, setCameFromPage,
    isRelated, windowWidth, isWizard, wizardGroup} = props;
  const fabricatorSettings = fabricatorData.settings;

  const goToFeatureInfo = () => {
    if (isRelated) {
      return false
    }
    const selectedFeature = shouldReplaceSelectionInfoFeature(currentFeature);
    toggleSelectionFeatureInfo(selectedFeature);
    setCameFromPage("materials"); // no more visualizer or shoppingcart switch
  };

  const showPriceLocked = getFeatureIsLocked(currentFeature);
  const showPrice = fabricatorSettings.showPricing && !fabricatorData.hideCheckoutBreakdownCost
    && !showPriceLocked && !fabricatorData.hidePricesFromUser;

  const handleRowItemClick = (event) => {
    if (isRelated) {
      return false
    }
    const preventFeatureClickClasses = [".m-button", ".m-quantity", ".m-triangle"];
    if (!isWizard && event && preventFeatureClickClasses.some(className => event.target.closest(className))) {
      return false
    }
    handleFeatureClick({part: currentFeature}, event);
  };

  const isMobile = windowWidth < 991;

  const infoButtonVisible = !isWizard || !wizardGroup || !wizardGroup.skipProductInfo;

  return (
    <div className={"m-item" + (isRelated ? " m-item--related" : "") + (currentFeature.dbFeature.updatedToolSettings
    && getDifferentToolSettings(currentFeature.dbFeature.updatedToolSettings, currentFeature.dbFeature.toolSettings).length
      ? " feature--updated" : "")} onClick={handleRowItemClick}>
      <div className={"m-item__thumbnail" + (selected ? " m-item__thumbnail--selected"  : "")} onDoubleClick={goToFeatureInfo}>
        <SuperAdminFeatureToolSettingsButton feature={currentFeature}/>
        <FeatureThumbnail feature={currentFeature}/>
        {!isRelated && isMobile ? (
          <span className="m-item__thumbnail-text">
            <RowItemRelatedProductsButton currentFeature={currentFeature}/>
          </span>
        ) : null}
        <FeatureCartItemsCount currentFeatureId={currentFeature.dbFeature.id}/>
      </div>
      <div className="m-item__content">
        <h2 className="product-info__title bold"><FeatureName feature={currentFeature}/></h2>
        <FeatureInfoDescription feature={currentFeature} brief={true}/>
        <div className="m-bottom">
          <div className="m-bottom__left">
            {showPrice ? <FeatureInfoPrice feature={currentFeature} unitAfter={true}/> : null}
            {showPriceLocked ? <FeatureInfoPriceLocked /> : null}
          </div>
          {!isRelated && !isMobile ? (
            <div className="m-bottom__center">
              <RowItemRelatedProductsButton currentFeature={currentFeature}/>
            </div>
          ) : null}
          <SelectionMainListRowItemButtons currentFeature={currentFeature}
                                           goToFeatureInfo={goToFeatureInfo}
                                           infoButtonVisible={infoButtonVisible}
                                           showPrice={showPrice}
                                           isRelated={isRelated}/>
        </div>
      </div>
    </div>
  )
};

RowItem.propTypes = {
  selected: PropTypes.bool,
  isRelated: PropTypes.bool,
  isWizard: PropTypes.bool,
  wizardGroup: PropTypes.shape(wizardGroupInterface),
  currentFeature: PropTypes.object.isRequired,
  handleFeatureClick: PropTypes.func.isRequired,
};

const mapStateToProps = (store) => {
  const {productNoteEditorVisible} = store.selectionState;
  const {adminToolSettingsPopupVisible} = store.adminState;
  return {
    productNoteEditorVisible,
    windowWidth: store.serverState.windowWidth,
    fabricatorData: store.fabricatorState,
    adminToolSettingsPopupVisible,
  };
};

const mapDispatchToProps = {
  toggleSelectionFeatureInfo,
  setCameFromPage
}

export default connect(mapStateToProps, mapDispatchToProps)(RowItem);
